/* eslint-disable prettier/prettier */
import React from 'react'
import ChatInput from './chatInput'
import styles from './styles'
import useSignal from '../../hooks/useSignal'
import ChatMessages from './chatMessages'

const Chat = ({ room, listOfMessages, roomId }) => {
  const { sendSignal } = useSignal({ room, roomId })

  const sendMessage = text => {
    if (room) sendSignal(text, 'text')
      console.log(listOfMessages)
  }

  const classes = styles()

  return (
    <div className={classes.chatContainer}>
      <ChatMessages
        chatClass={classes.chatMessages}
        chatMessages={listOfMessages}
      >
      </ChatMessages>
      <div className={classes.chatInput}>
        <ChatInput sendMessage={sendMessage}></ChatInput>
      </div>
    </div>
  )
}

export default Chat